<template>
  <div class="title-wrapper" :class="{ 'special-type': type === '特殊' }">
    <!-- 特殊类型：带 TOP3 按钮和设置图标 -->
    <div v-if="type === '特殊'" class="title-header special">
      <div class="title-left">
        <div class="hexagon-icon">
          <span class="icon-symbol">N</span>
        </div>
        <span class="title-text">{{ title }}</span>
      </div>
      <div class="title-right">
        <span class="top3-btn">TOP3</span>
        <i class="el-icon-setting setting-icon" @click="handleSetting"></i>
      </div>
    </div>

    <!-- 普通类型：只显示图标和文字 -->
    <div v-else class="title-header normal">
      <div class="hexagon-icon">
        <span class="icon-symbol">¥</span>
      </div>
      <span class="title-text">{{ title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Title',
  props: {
    type: {
      type: String,
      default: '普通',
      validator: (value) => ['普通', '特殊'].includes(value)
    },
    title: {
      type: String,
      default: '疾病收入大盘/7天'
    }
  },
  methods: {
    handleSetting() {
      this.$emit('setting-click')
    }
  }
}
</script>

<style lang="scss" scoped>
.title-wrapper {
  width: 100%;
  
  .title-header {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    border: 1px solid #74ffbe;
    background: rgba(0, 0, 0, 0.3);
    position: relative;
    min-height: 40px;

    // L形角标记
    &::before {
      content: '';
      position: absolute;
      top: -1px;
      left: -1px;
      width: 12px;
      height: 12px;
      border-top: 2px solid #74ffbe;
      border-left: 2px solid #74ffbe;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: -1px;
      right: -1px;
      width: 12px;
      height: 12px;
      border-bottom: 2px solid #74ffbe;
      border-right: 2px solid #74ffbe;
    }

    &.special {
      justify-content: space-between;
    }

    &.normal {
      justify-content: flex-start;
      gap: 10px;
    }

    .title-left {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .hexagon-icon {
      width: 20px;
      height: 20px;
      background-color: #74ffbe;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      clip-path: polygon(30% 0%, 70% 0%, 100% 50%, 70% 100%, 30% 100%, 0% 50%);
      flex-shrink: 0;

      .icon-symbol {
        color: #fff;
        font-size: 12px;
        font-weight: bold;
        line-height: 1;
        z-index: 1;
      }
    }

    .title-text {
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      white-space: nowrap;
    }

    .title-right {
      display: flex;
      align-items: center;
      gap: 0;
      border-radius: 4px;
      overflow: hidden;

      .top3-btn {
        background-color: #74ffbe;
        color: #0d1014;
        padding: 6px 14px;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.3s;
        border-radius: 4px 0 0 4px;
        white-space: nowrap;
        line-height: 1;

        &:hover {
          background-color: #60fcb2;
        }
      }

      .setting-icon {
        background-color: rgba(116, 255, 190, 0.15);
        color: #fff;
        padding: 6px 10px;
        font-size: 16px;
        cursor: pointer;
        transition: all 0.3s;
        border-radius: 0 4px 4px 0;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          background-color: rgba(116, 255, 190, 0.25);
          color: #74ffbe;
        }
      }
    }
  }
}
</style>

